module.exports = __webpack_public_path__ + "static/img/bg_mobile.9c784ee7.webp";